import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-change",
  "use": "icon-change-usage",
  "viewBox": "0 0 28 26",
  "content": "<symbol viewBox=\"0 0 28 26\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-change\">\r\n<path d=\"M18.8 14.3L27.9 7.29995L18.8 0.199951L18.8 4.49995L7.90002 6.49995L7.90002 8.09995L18.8 10.1L18.8 14.3Z\" fill=\"#35B14A\" />\r\n<path d=\"M9.20001 11.7L0.100013 18.7L9.20001 25.8L9.20001 21.5L20.2 19.6L20.2 18.8L20.2 18.7L20.2 17.9L9.20001 16L9.20001 11.7Z\" fill=\"#F04923\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol